module.exports = __webpack_public_path__ + "static/media/emergency-diagnosis.827a5ad1.svg";